

    import React,{Component} from 'react';

	// import {BrowserRouter,Route,Link} from 'react-router-dom';
	 import axios from "axios";


	
	 
	class DeleteUsersComponent extends Component{
	
		constructor(props)
		{
			super(props)
			
			this.state = {
				id: null
			}
		}
	  
       async componentDidMount()
        {

            
    //check if user is registered and logged in

    try{
        //get user access token
        let token = localStorage.getItem("token");
                        
        if((token === "noToken") || (token === null))
        {
        alert("Ilegal page view");
        this.props.history.push("/");
        }
    
        let userDataResponse = await axios({
        method: "get",
        url: "http://mofehintolumumuni.com/gitserver/api/users/profile",
        headers: {"Authorization": "Bearer "+token}
        });
    
        let requestStatus = userDataResponse.data.status;
        //let payload = userDataResponse.data.data
    
        if(requestStatus !== "success")
        {
    
            //redirect away from dashboard
            this.props.history.push("/gitsearch/");
    
        }
       
    
        }
        catch(error)
        {
            alert("Cannot view resource please refresh page."+error);
            this.props.history.push("/gitsearch/");
        }
    
    

              //make verification api call
                this.setState({id:this.props.match.params.id});

                if((this.state.id !== null) && (this.state.id !== ""))
                {
                    //make api call for delete
                    
                    try{

                        let token = localStorage.getItem("token");

                        let response  =  await axios({
                            method: "delete",
                            url: "http://mofehintolumumuni.com/gitserver/api/users/preference/github/usersearch/delete",
                            data: {id:this.state.id},
                            headers: {"Authorization": "Bearer "+token}
                            });

                        let status = response.data.status;
                        

                        if(status === "success")
                        {
                            alert("Data deleted successfully");
                            this.props.history.push("/gitsearch/dashboard");
                        }else
                        {
                            alert("Data not deleted successfully");
                            this.props.history.push("/gitsearch/dashboard");
                        }
            
                    }
                    catch(error)
                    {
                        alert(`Delete process not successful`);
                        this.props.history.push("/gitsearch/dashboard");
                       
                    }
                }
                else
                {
                    alert("Invalid id parameter");
                    this.props.history.push("/gitsearch/dashboard");
                }


        }

        componentDidUpdate()
        {
           // alert("componentDidUpdate");
        }

        componentWillUpdate()
        {
           // alert("componentWillUpdate");
        }

    


	render()
	{
	return(
	
		<React.Fragment>
		<section>
		<div id="page-wrapper" className="sign-in-wrapper">
				<div className="graphs">
					<div className="sign-in-form">
						<div className="sign-in-form-top">
							<h1>DELETE USER!  <i className="fa fa-cogs"></i></h1>
						</div>
					
					</div>
				</div>
			</div>
			</section>
</React.Fragment>

	);
	}


    }
    



    export default DeleteUsersComponent;


